// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7855) return "static/chunks/7855-de177c9aeeaf18e7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1358":"a0cd355cd5d0ac59","2918":"bfadf675448b7227","5171":"7f79d028fa7973cd"}[chunkId] + ".js";
};